import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Divider, Grid, Paper } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import {
  checkoutGateEntryDetail,
  loader,
  vehicleRegistrationNumbers,
} from "src/app-redux/gate-entry/gateEntrySlice";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import TabHeader from "src/components/TabHeader/TabHeader";
import GateOutDetails from "./components/GateOutDetails";
import GateOutInput from "./components/GateOutInput";
import { useStyles } from "./components/style";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import { loader as loader2 } from "src/app-redux/vehicle/vehicleSlice";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {};

export default function GateOut({}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [moduleName, setmoduleName] = useState<any>("Gate Entry");
  const [pageHeading, setPageHeading] = useState("Gate-Out");
  // Select from Store
  const vehicleNumbersArr = useAppSelector(vehicleRegistrationNumbers);
  const loading = useAppSelector(loader);
  const loading2 = useAppSelector(loader2);
  const params: any = useParams();
  const [selectedVehicleDetails, setSelectedVehicleDetails] = useState<any>(null);
  const vehicleDetails = useAppSelector(checkoutGateEntryDetail);

  useEffect(() => {
    if (params.id) {
      getVehicleDetails();
    }
  }, []);
  useEffect(() => {
    setSelectedVehicleDetails(vehicleDetails);
  }, [vehicleDetails]);
  const getVehicleDetails = async () => {
    const res = await dispatch(getVehicleDetailsByIdAction(params.id));
    setSelectedVehicleDetails(res.payload.vehicleDetail);
  };

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={"/gate-entry"} />
      <Backdrop className={classes.backdrop} open={loading || loading2}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>
            {/* Content Start */}
            <Grid spacing={2} container>
              {/* Left Side */}
              <Grid
                container
                spacing={2}
                item
                md={7}
                style={{ padding: "30px", maxHeight: "600px" }}
              >
                <GateOutInput
                  vehicleNumbers={vehicleNumbersArr}
                  vehicleDetails={selectedVehicleDetails}
                />
              </Grid>
              {/* End Left Side */}

              {/* Right Side */}
              <Grid item md={5} style={{ backgroundColor: "#F5F5F5", paddingLeft: "25px" }}>
                <GateOutDetails vehicleDetails={selectedVehicleDetails} />
              </Grid>
              {/* End Right Side */}
            </Grid>
            {/* ./Content Start */}
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
